<template>
  <div :class="{ 'soldout' : product.in_stock <= 0 }" class="page product-item d-flex mb-4 offer">
    <b-link :to="makeBreadcrumbLink(product)" class="product-image">
      <div
          v-if="product.image"
          class="plimg"
          :aria-label="product.name"
          :style="getImageURL(product)">
      </div>
      <div
          v-else
          class="plimg"
          :aria-label="product.name"
          style="background-image:url('images/no-data-found.png');">
      </div>
      <div class="brandlogo" v-if="product.brand.image_path != null" v-bind:style="{ backgroundImage: 'url(' + product.brand.image_base_path+product.brand.image_path + ')' }" ></div>
      <div class="brandlogo-noimage" v-else style="background-image:url('images/nologo.png');"></div>
    </b-link>

    <b-link :to="makeBreadcrumbLink(product)" class="product-info">
      <h3 class="mb-2">{{ product.name }}</h3>
      <!-- <ul class="eulabels pt-2 pb-2">
          <li><span class="eulabels-tag fuel-tag" :class="`level-`+product.fuel_effiency"><i class="fas fa-gas-pump"></i> {{product.fuel_effiency}}</span></li>
          <li><span class="eulabels-tag wet-tag" :class="`level-`+product.wet_grip"><i class="fas fa-cloud-showers-heavy"></i> {{product.wet_grip}}</span></li>
          <li>
              <span class="eulabels-tag noice-tag">
                  <i class="fas">
                      <img v-if="product.noice_value < 69" src="../../public/images/volumeicon/vol1.png" />
                      <img v-else-if="product.noice_value >= 69 && product.noice_value < 73" src="../../public/images/volumeicon/vol2.png" />
                      <img v-else  src="../../public/images/volumeicon/vol3.png" />
                  </i>
                  {{product.noice_value}}
              </span>
          </li>
      </ul>
      <p class="pb-3 rc-block rc-label" v-if="product.is_recycled == '0'"><img class="rc-icon" src="../../public/images/recycling_icon.png" /><span class="rc-label-span">{{ $t('Recycling fee included') }}</span></p>
      <p v-if="product.available_quantity >= 4" class="text-success text-right font-weight-bold">{{ $t('In stock') }}</p>
      <p v-else class="text-danger text-right font-weight-bold">{{ $t('Available qty:') }} {{ product.available_quantity }}</p> -->
    </b-link>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "SingleProduct",
  props : ["product"],
  computed : {
      ...mapGetters("app", ['currentLang'])
  },
  methods : {
    getImageURL(product) {
      return "backgroundImage: url('" + product.image.image_base_path+product.image.path + "')";
    }
  }
}
</script>

<style scoped>
.page .product-item { flex-direction:column;}
.page .product-item .product-image, .product-item .product-info, .page .product-image { flex-basis: 100%; }
</style>
